export const RESOURCE_TYPE = {
  MAIN: 'main',
  NESTED: 'nested',
  PARALLEL: 'parallel'
}

// todo: rm the following line (compatible with old code)
export const resourceType = RESOURCE_TYPE

export const MODE = {
  EDIT_IN_DIALOG: 1,
  EDIT_IN_NEW_PAGE: 2,
  EDIT_IN_TABLE: 3
}

export const VIEW_MAP = {
  LIST: 'list',
  ADD: 'add',
  EDIT: 'edit',
  DETAIL: 'detail'
}

export default {
  RESOURCE_TYPE,
  MODE,
  VIEW_MAP
}



// WEBPACK FOOTER //
// ./packages/constant/index.js